<template lang="pug">
div
  div( v-if="loading" ) Loading...
  div( v-else )
    div( class="alert alert-danger" v-if="error" ) {{ error }}
    div
      div( class="text-right mb-2" )
        button( v-on:click="aiAskQuestionsAndDoActions" class="btn btn-primary" ) Ask Questions and Do Actions
      
      hr

      div(
        v-for="result in audit.aiQuestionResults"
        v-bind:key="result.id"
        class="ibox"
      )
        div( class="ibox-content" )
          div( class="mb-2" )
            strong Question ID:&nbsp;
            | {{ result.questionId }}

          div( class="mb-2 break-word" )
            strong Story:&nbsp;
            | {{ result.story }}

          div
            strong Action Taken:&nbsp;
            | {{ result.actionTaken }}

</template>

<style lang="scss">
.break-word {
  word-break: break-word;
}
</style>

<script>
import Vue from 'vue'
import { onMounted, ref } from '@vue/composition-api'
import { api } from '@/api'
export default Vue.extend({
  
  props: {
    audit: {
      required: true,
    },
  },

  setup(props) {
    
    const { audit } = props
    const loading = ref(false)
    const error = ref()
    const aiQuestionResults = ref([])

    async function aiAskQuestionsAndDoActions() {
      loading.value = true
      try {
        const res = await api('POST', `/gemini/ai-questions/audits/${audit.id}`)
        if (!res.ok) {
          error.value = await res.text()
          return
        }
        audit.aiQuestionResults.value = await res.json()
        error.value = ''
      } catch (e) {
        console.error(`aiAskQuestionsAndDoActions`, e)
        error.value = e.message
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      aiQuestionResults,
      aiAskQuestionsAndDoActions,
      error,
    }
  }
})
</script>